import Header from "@/components/Header";
import Hero from "@/components/Hero";
import PillarsStrip from "@/components/PillarsStrip";
import Problem from "@/components/Problem";
import Comparativa from "@/components/Comparativa";
import System360 from "@/components/System360";
import Automation from "@/components/Automation";
import Benefits from "@/components/Benefits";
import CasoCarways from "@/components/CasoCarways";
import Calculadora from "@/components/Calculadora";
import TablaComparativa from "@/components/TablaComparativa";
import ParaQuienEs from "@/components/ParaQuienEs";
import Guarantee from "@/components/Guarantee";
import FAQ from "@/components/FAQ";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="relative bg-[#050505] text-white overflow-x-hidden">
      <Header />
      <Hero />
      <PillarsStrip />
      <Problem />
      <Comparativa />
      <System360 />
      <Automation />
      <Benefits />
      <CasoCarways />
      <Calculadora />
      <TablaComparativa />
      <ParaQuienEs />
      <Guarantee />
      <FAQ />
      <FinalCTA />
      <Footer />
    </main>
  );
}
